import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./styles.module.css";

const ImageCarousel = ({ images }) => {
  const [current, setCurrent] = useState(0);

  const settings = {
    dots: false,
    arrows: false,   // Hide arrows
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.carousel_container}>
      <Slider {...settings}>
        {images.map((src, idx) => (
          <div key={idx} className={styles.carousel_slide}>
            <img src={src} alt={`slide-${idx}`} />
          </div>
        ))}
      </Slider>
      <div className={styles.carousel_counter}>
        {current + 1} / {images.length}
      </div>
    </div>
  );
};

export default ImageCarousel;
